<template>
  <div>
    <b-overlay
      id="overlay-background"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-table
        :fields="fields"
        :items="rows"
        hover
        responsive
        striped
        show-empty
      >
        <template #cell(order_flag)="data">
          <div class="font-weight-bold">
            <b-badge :variant="getFlagBadgeColor(data.value.type)">
              {{ data.value.name }}
            </b-badge>
          </div>
        </template>
        <template #cell(data)="data">
          <div
            v-if="data.value && data.value.other_data"
            class="font-weight-bold"
          >
            {{ `${data.value.other_data.remark ? data.value.other_data.remark : '---'}` }}
          </div>
          <div
            v-else
            class="font-weight-bold"
          >
            {{ `${data.value && data.value.remark ? data.value.remark : '---'}` }}
          </div>
        </template>
        <template #cell(flaged_status_key)="data">
          <div>
            <order-status-badge :status-key="data.value" />
          </div>
        </template>
        <template #cell(flagged_date)="data">
          <div
            class="font-weight-bold"
          >
            {{ data.value ? __dateTimeFormatter(data.value) : '---' }}
          </div>
        </template>
        <template #cell(flagged_by)="data">
          <div
            v-if="data.value"
            class="d-flex align-items-center"
          >
            <b-avatar
              :text="avatarText(data.value.user_type)"
              size="32"
              variant="light-primary"
              class="mr-1"
            />
            <div>
              <div class="font-weight-bold">
                {{ data.value.first_name }} {{ data.value.last_name }}
              </div>
              <div class="font-small-2">
                {{ data.value.reference_id }}
              </div>
              <small>{{ data.value.role_name }}</small>
            </div>
          </div>
          <div
            v-else
            class="font-weight-bold"
          >
            {{ '---' }}
          </div>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay,
  BTable,
  BBadge,
  BAvatar,
} from 'bootstrap-vue'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BTable,
    BOverlay,
    BBadge,
    OrderStatusBadge,
    BAvatar,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    flag_data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      avatarText,
      sort: '',
      id: '',
      fields: [
        {
          key: 'order_flag',
          label: 'Flag',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'data',
          label: 'Remark',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'flaged_status_key',
          label: 'Status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'flagged_date',
          label: 'Flagged Date',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'flagged_by',
          label: 'Flagged By',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    rows() {
      return this.flag_data
    },
  },
  methods: {
    getFlagBadgeColor(type) {
      if (type === 'flag_1') {
        return 'light-info'
      }
      if (type === 'flag_2') {
        return 'light-danger'
      }
      if (type === 'flag_3') {
        return 'light-primary'
      }
      if (type === 'flag_4') {
        return 'light-dark'
      }
      if (type === 'flag_5') {
        return 'light-success'
      }
      if (type === 'flag_6') {
        return 'light-warning'
      }
      if (type === 'flag_7') {
        return 'light-danger'
      }
      if (type === 'flag_8') {
        return 'light-info'
      }
      return 'light-primary'
    },
  },
}
</script>
